<template>
    <div class="appdetail">
        <el-drawer :visible.sync="drawer" custom-class="detailDrawer" size="100%" :withHeader="false" :modal-append-to-body="true" :modal="false" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.5)">
            <!-- 标题、按钮 -->
            <div class="appdetail-title">
                <div class="appdetail-title-top clearfix">
                    <div class="app-titles">
                        <i :class="currentSelectMenuData.css" class="app-title-icon"></i>
                        <span class="app-title-main">报表文件</span> 
                    </div>
                    <div class="app-buttons">
                        <i class="el-icon-close appdetail-close" @click="closeBtn"></i>
                    </div>
                </div>
            </div>
            <div class="appdetail-content" :style="{height: 'calc(100vh - 91px)'}">
                <iframe :src="src" width="100%" :height="fullHeight" frameborder="0" scrolling="auto">
                </iframe>
            </div>
        </el-drawer>
  </div>
</template>

<script>

export default {
  name: 'reportfiledetail',
  data() {
    return {
      drawer:false,
      report_url: Config.report_url,
      fullHeight: document.documentElement.clientHeight - 150 + 'px',//获取浏览器高度
      innerVisible: false,
      show: false,
      url: '',
      src: '',
      isok1: true,
      isok2: false,
      addtitle: false,
      loading:false,
      previewtitle:false,
      isdefaultmax: true,
    }
  },
  methods: {
    //添加
    addBtn() {
      this.$store.commit('setmenuAndDrawer',true)
      var token = this.getCookie('access_token');
      this.src = this.report_url + '/reportFile/page/create?access_token=' + token;
      console.log(this.src);
      this.addtitle = true;
      this.drawer = true;
    },
    //修改报表
    view(item) {
      var token = this.getCookie('access_token');
      this.src = this.report_url + '/reportFile/page/edit?id=' + item.id + '&access_token=' + token;
      console.log(this.src);
      this.addtitle = false;
      this.previewtitle=false;
      this.drawer = true;
    },
    //预览报表
    preview(id) {
      var token = this.getCookie('access_token');
      this.src = this.report_url + '/reportFile/page/preview?id=' + id + '&access_token=' + token;
      console.log(this.src);
      this.previewtitle = true;
      this.drawer = true;
    },
    //取消
    // toggle(e) {
    //   if (this.isok1 == true) {
    //     this.maxDialog();
    //   } else {
    //     this.rebackDialog();
    //   }
    // },
    // maxDialog(e) { //定义大弹出框一个默认大小
    //   this.isok1 = false;
    //   this.isok2 = true;
    //   $(".mask_div").width(document.body.clientWidth);
    //   $(".mask_div").height(document.body.clientHeight - 70);
    //   $(".mask_div").css("top", "-40px");
    // },
    // //还原按钮
    // rebackDialog() { //大弹出框还原成默认大小
    //   this.isok1 = true;
    //   this.isok2 = false;
    //   $(".mask_div").css("width", "80%");
    //   $(".mask_div").css("height", "80%");
    //   $(".mask_div").css("top", "100px");
    // },
    //关闭抽屉按钮点击
    closeBtn(){
        this.drawer = false
    },
    //计算抽屉大小
    initDetailDrawer(){
        if((document.documentElement.clientWidth * 0.7) < 900){
            document.getElementsByClassName("detailDrawer")[0].parentNode.parentNode.style.left = "calc(100% - 900px)"
        }else{
            document.getElementsByClassName("detailDrawer")[0].parentNode.parentNode.style.left = "30%"
        }
    },
  },
  mounted() {
    this.initDetailDrawer()  //初始化计算详情抽屉高度
      //窗口大小发生变化时，重新计算详情抽屉高度
      window.onresize = ()=> {
          if(document.getElementsByClassName("detailDrawer").length > 0){
              this.initDetailDrawer()
          }
      }
  },
  computed:{
      //当前左侧菜单选中的信息
      currentSelectMenuData(){
          return this.$store.state.currentSelectMenuData
      },
      //左侧菜单以及应用详情抽屉显示状态
      menuAndDrawer(){
          return this.$store.state.menuAndDrawer
      },
      //当前登录人信息
      currentuser() {
          return this.$store.state.currentuser
      },
  },
}
</script>

<style>
/* @import "../../assets/css/mask-modules.css"; */
.masks {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  display: block;
  top: 0px;
  z-index: 1000;
  margin-top: 60px;
}
.masks_div {
  position: absolute;
  z-index: 1001;
  width: 100%;
  background: #f3f6fa;
  border-radius: 0px;
  height: 100%;
  top: 0px;
  bottom: 0px;
  overflow: hidden;
}
</style>
